// extracted by mini-css-extract-plugin
export default {"review":"reviews-list_review__Cxymb"};